import Service from "./service.abstract";

export default class MessageHomeIntermediationService extends Service {
  constructor(url: string) {
    super();

    this.url = url;
    this.errorTopic = "service.error.messagehomeintermediationservice";
  }
}
